module.exports = __webpack_public_path__ + "img/icon-street.3880878c.svg";